// ===== DEV BYPASS ===== 
//disable auth/paid gating in dev
//WRITE const authEnabled = !isDev;

import React, { useState, useContext, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";
import { useIsPaidUser } from "./hooks/useIsPaidUser";
import "./css/CoursesPage.css";
import financeImg from "./images/finance.png";
import agencyImg from "./images/agency.png";
import softwareImg from "./images/softwareIQ.JPG";
import investImg from "./images/investparabr.jpg";

const apiUrl = "https://qedeefqyh2.execute-api.us-west-2.amazonaws.com/prod";
const API_URL   = process.env.REACT_APP_API_URL;
const AUDIENCE  = process.env.REACT_APP_AUTH0_AUDIENCE;

//const isDev = process.env.NODE_ENV === "development";
const authEnabled = true;

const CoursesPage = () => {
  const { isAuthenticated, loginWithRedirect, user, getAccessTokenSilently } = useAuth0();
  // helper to b64-decode safely
  const b64 = (s) => JSON.parse(atob(s.replace(/-/g, "+").replace(/_/g, "/")));

  const { language, toggleLanguage, translations } = useContext(LanguageContext);

  const [showInvestParaBr, setShowInvestParaBr] = useState(false); 
  const [showPersonalFinance, setShowPersonalFinance] = useState(false);
  const [showStockTrading, setShowStockTrading] = useState(false);
  const [showSoftwareIq, setShowSoftwareIq] = useState(false);
  const history = useHistory();

  const { isPaidUser, isCheckingPaid } = useIsPaidUser("personal-finance");
  const effectiveIsAuthenticated = authEnabled ? isAuthenticated : true;
  const effectiveIsPaidUser = authEnabled ? isPaidUser : true;
  const effectiveIsCheckingPaid = authEnabled ? isCheckingPaid : false;




  const startRoutes = {
    investParaBr: "/investparabr",
    personalFinance: "/personal-finance",
    stockTrading: "/stock-trade",
    };






  useEffect(() => { window.scrollTo(0, 0); }, []);



// useEffect(() => {
//   let alive = true;

//   (async () => {
//     try {
//       // Only try if logged in; otherwise the hook’s gating will handle redirects
//       if (!isAuthenticated) return;

//       // 1) Force an ACCESS token for your API (not an ID token)
//       const resp = await getAccessTokenSilently({
//         authorizationParams: {
//           audience: AUDIENCE,
//           scope: "read:is-paid", // your API scope
//         },
//         detailedResponse: true,
//         cacheMode: "off", // bypass any cached ID-token path
//       });

//       if (!alive) return;

//       const at = resp?.access_token || "";
//       const parts = at.split(".").length;
//       console.log("[CoursesPage] ACCESS token parts:", parts);
//       try { console.log("[CoursesPage] ACCESS header:", b64(at.split(".")[0])); } catch {}

//       // If not a 3-part JWS, stop here and don’t call the backend
//       if (parts !== 3) {
//         console.warn("[CoursesPage] Not a JWS access token. Check Provider audience/scope and ensure no earlier getAccessTokenSilently() without audience is running.");
//         return;
//       }

//       // 2) Call your backend only with a valid ACCESS token
//       const res = await fetch(`${API_URL}/is-paid?course=personal-finance`, {
//         method: "GET",
//         headers: { Authorization: `Bearer ${at}` },
//       });

//       if (!alive) return;

//       if (!res.ok) {
//         console.warn("[/is-paid] HTTP", res.status);
//         return;
//       }

//       const data = await res.json().catch(() => ({}));
//       console.log("[/is-paid] response:", data);
//       // if you want: setIsPaidUser(data.isPaid);

//     } catch (e) {
//       console.warn("[CoursesPage] ACCESS fetch failed:", e?.message || e);
//     }
//   })();

//   return () => { alive = false; };
// }, [isAuthenticated, getAccessTokenSilently]);



  const courseHero = {
    investParaBr: {src: investImg, alt: translations.InvestindonosEuaCourse },
    personalFinance: { src: financeImg, alt: translations.personalFinance },
    stockTrading: { src: agencyImg, alt: translations.stockTradingBasicsTitle },
    software: { src: softwareImg, alt: translations.softwareIndustry },
  };

  const HeroImage = ({ src, alt, cta, onClick }) => (
    <div className="course-hero">
      <div className="image-wrapper">
        <img src={src} alt={alt} loading="lazy" />
        {cta && <button className="overlay-btn" onClick={onClick}>{cta}</button>}
      </div>
    </div>
  );

  // Helper for "Start" buttons
  const goTo =
    (path, requireAuth = false) =>
    async () => {
      const mustAuth = authEnabled && requireAuth;
      if (mustAuth && !effectiveIsAuthenticated) {
        localStorage.setItem("auth_redirect_path", path);
        await loginWithRedirect({ appState: { returnTo: path } });
        return;
      }
      history.push(path);
    };

  return (
    <div className="page-wrapper">
      <button className="language-button" onClick={toggleLanguage}>
        {language === "en" ? "🇧🇷 Português" : "🇺🇸 English"}
      </button>

      <div className="courses-page">
        <h1>
          {translations.courses}
          {!authEnabled && <span style={{ marginLeft: 8, fontSize: 12, opacity: 0.7 }}>(Dev mode: auth bypass)</span>}
        </h1>

        {/* Investindo nos EUA para Brasileiros – Manual Completo (NEW) */}
        <div className="invest-para-br">
          <span className="course-badge course-badge--trial">
            {language === "pt" ? "Módulo 0 Grátis" : "Module 0 Free"}
          </span>
          <h2
            onClick={() => setShowInvestParaBr((s) => !s)}
            className="toggle-heading"
          >
            {translations.InvestindonosEuaCourse}
            <span className={`arrow ${showInvestParaBr ? "open" : ""}`}>&gt;</span>
          </h2>

          <HeroImage
            src={courseHero.investParaBr.src}
            alt={courseHero.investParaBr.alt}
          />

          {showInvestParaBr && (
            <div className="modules">
              <p style={{ marginBottom: 12 }}>
                {translations.investnoseuadescription}
              </p>

              <div style={{ margin: "8px 0 16px" }}>
                <button
                  className="lesson-link"
                  style={{ padding: "8px 14px", borderRadius: 8 }}
                  // Sem autenticação obrigatória – curso free
                  onClick={goTo(startRoutes.investParaBr, false)}
                >
                  {translations.irparaocurso}
                </button>
              </div>

              {/* Se quiser, você pode adicionar bullets aqui depois */}
            </div>
          )}
        </div>

        {/* Personal Finance */}
        <div className="personal-finance">
          <span className="course-badge course-badge--trial">
            {language === "pt" ? "Módulo 0 Grátis" : "Module 0 Free"}
          </span>
          <h2 onClick={() => setShowPersonalFinance((s) => !s)} className="toggle-heading">
            {translations.personalFinance} <span className={`arrow ${showPersonalFinance ? "open" : ""}`}>&gt;</span>
          </h2>
          <HeroImage src={courseHero.personalFinance.src} alt={courseHero.personalFinance.alt} />
          {showPersonalFinance && (
            <div className="modules">
              <p style={{ marginBottom: 12 }}>
                {translations.personalDescription}
              </p>

              <div style={{ margin: "8px 0 16px" }}>
                <button
                  className="lesson-link"
                  style={{ padding: "8px 14px", borderRadius: 8 }}
                  onClick={goTo(startRoutes.personalFinance, false)}
                >
                  {translations.irparaocurso}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Stock Trading (now separate course) */}
        <div className="stock-trading">
          <span className="course-badge course-badge--free">
            {language === "pt" ? "Grátis" : "Free"}
          </span>
          <h2 onClick={() => setShowStockTrading((prev) => !prev)} className="toggle-heading">
            {translations.stockTradingBasicsTitle}
            <span className={`arrow ${showStockTrading ? "open" : ""}`}>&gt;</span>
          </h2>
          <HeroImage src={courseHero.stockTrading.src} alt={courseHero.stockTrading.alt} />
          {showStockTrading && (
            <div className="modules">
              <p style={{ marginBottom: 12 }}>
                {translations.stockTradingDescription}
              </p>

              <div style={{ margin: "8px 0 16px" }}>
                <button
                  className="lesson-link"
                  style={{ padding: "8px 14px", borderRadius: 8 }}
                  onClick={goTo(startRoutes.stockTrading, false)}
                >
                  {translations.irparaocurso}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Software IQ */}
        <div className="software-iq">
          <h2 onClick={() => setShowSoftwareIq((prev) => !prev)} className="toggle-heading">
            {translations.softwareIndustry}
            <span className={`arrow ${showSoftwareIq ? "open" : ""}`}>&gt;</span>
          </h2>
          <HeroImage src={courseHero.software.src} alt={courseHero.software.alt} />
          {showSoftwareIq && <div className="course-description"><p>{translations.comingSoon || "Em breve"}</p></div>}
        </div>
      </div>
    </div>
  );
};

export default CoursesPage;
